"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: login/unrecognized-device-unauthenticated-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Flogin%2Funrecognized-device-unauthenticated-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnrecognizedDeviceUnauthenticatedServiceClient = exports.BlockUnrecognizedDeviceResponse = exports.BlockUnrecognizedDeviceRequest = exports.GetUnrecognizedDeviceResponse = exports.GetUnrecognizedDeviceRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const unrecognized_device_1 = require("./unrecognized-device");
const protobufPackage = 'com.step.login.proto';
function createBaseGetUnrecognizedDeviceRequest() {
    return { token: '' };
}
exports.GetUnrecognizedDeviceRequest = {
    fromJSON(object) {
        const message = {
            token: isSet(object.token) ? globalThis.String(object.token) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== '') {
            obj.token = message.token;
        }
        return obj;
    },
    create(base) {
        return exports.GetUnrecognizedDeviceRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUnrecognizedDeviceRequest();
        message.token = object.token ?? '';
        return message;
    },
};
function createBaseGetUnrecognizedDeviceResponse() {
    return { unrecognizedDevice: unrecognized_device_1.UnrecognizedDevice.fromPartial({}) };
}
exports.GetUnrecognizedDeviceResponse = {
    fromJSON(object) {
        const message = {
            unrecognizedDevice: isSet(object.unrecognizedDevice)
                ? unrecognized_device_1.UnrecognizedDevice.fromJSON(object.unrecognizedDevice)
                : unrecognized_device_1.UnrecognizedDevice.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.unrecognizedDevice !== undefined) {
            obj.unrecognizedDevice = unrecognized_device_1.UnrecognizedDevice.toJSON(message.unrecognizedDevice);
        }
        return obj;
    },
    create(base) {
        return exports.GetUnrecognizedDeviceResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUnrecognizedDeviceResponse();
        message.unrecognizedDevice =
            (object.unrecognizedDevice !== undefined && object.unrecognizedDevice !== null)
                ? unrecognized_device_1.UnrecognizedDevice.fromPartial(object.unrecognizedDevice)
                : unrecognized_device_1.UnrecognizedDevice.fromPartial({});
        return message;
    },
};
function createBaseBlockUnrecognizedDeviceRequest() {
    return { token: '' };
}
exports.BlockUnrecognizedDeviceRequest = {
    fromJSON(object) {
        const message = {
            token: isSet(object.token) ? globalThis.String(object.token) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== '') {
            obj.token = message.token;
        }
        return obj;
    },
    create(base) {
        return exports.BlockUnrecognizedDeviceRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlockUnrecognizedDeviceRequest();
        message.token = object.token ?? '';
        return message;
    },
};
function createBaseBlockUnrecognizedDeviceResponse() {
    return {};
}
exports.BlockUnrecognizedDeviceResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.BlockUnrecognizedDeviceResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseBlockUnrecognizedDeviceResponse();
        return message;
    },
};
/**
 * Unrecognized Devices Unauthenticated API.
 */
class UnrecognizedDeviceUnauthenticatedServiceClient {
    rpc;
    name = 'com.step.login.proto.UnrecognizedDeviceUnauthenticatedService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/login';
    methods = [{
            name: 'GetUnrecognizedDevice',
            requestType: exports.GetUnrecognizedDeviceRequest,
            responseType: exports.GetUnrecognizedDeviceResponse,
            authenticationOptions: undefined,
        }, {
            name: 'BlockUnrecognizedDevice',
            requestType: exports.BlockUnrecognizedDeviceRequest,
            responseType: exports.BlockUnrecognizedDeviceResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    getUnrecognizedDevice(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    blockUnrecognizedDevice(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.UnrecognizedDeviceUnauthenticatedServiceClient = UnrecognizedDeviceUnauthenticatedServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=unrecognized-device-unauthenticated-service.js.map